import axios from 'axios'
import qs from 'qs'
import store from '@/store'

import { Toast } from 'vant'

const host = process.env.NODE_ENV === 'development' ? 'http://localhost:8000/' : 'https://api.tbxprint.com/'
const api = host + 'api/'
const timeout = 500

export default {
  host: host,
  async post (uri, params, success, failure, silent) {
    uri = api + uri
    if (!silent) Toast.loading({message: '加载中', duration: 0})
    let config = {
      headers: {
        'token': params === null || params.token === undefined ? store.state.permission.token : params.token
      }
    }
    await axios.post(uri, qs.stringify(params), config)
      .then(res => {
        setTimeout(() => {
          Toast.clear()
        }, timeout)
        res = res.data
        if (res.code === 30000) {
          if (undefined !== failure) failure(res)
          else store.commit('permission/REMOVE_TOKEN')
        } else if (res.code === 200) {
          if (undefined !== success) success(res)
          else Toast(res.msg)
        } else {
          if (undefined !== failure) failure(res)
          else Toast(res.msg)
        }
      })
      .catch(error => {
        setTimeout(() => {
          Toast.clear()
          Toast('接口交互异常')
        }, timeout)
        console.log(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js